import Blends from "../../pages/Blends";
import NewBlendStudy from "../../pages/Blends/NewBlends";
import { InternalAndGuestUserRoles, InternalUserRoles, Role } from "../../constants/roles";
import { ReactComponent as BlendsIcon } from "../../assets/blendsicon.svg";
import PrepareBatch from "../../pages/Blends/EditBatch";
import { ModuleRouteConfig, RouteConfig } from "../types";

export const BASE_PATH = "/blends";
const accessRoles: Role[] = InternalAndGuestUserRoles;

export const baseRoute: ModuleRouteConfig = {
  path: BASE_PATH,
  component: Blends,
  allowedRoles: accessRoles,
  label: "Blends",
  icon: () => <BlendsIcon />,
  isCustomIcon: true,
  hasDivider: false,
};

export const blendsRoutes: { [key: string]: RouteConfig } = {
  blends: baseRoute,
  newBlendStudy: {
    path: "/blendstudy",
    component: NewBlendStudy,
    allowedRoles: InternalUserRoles,
  },
  prepareBatch: {
    path: "/prepareBatch",
    component: PrepareBatch,
    allowedRoles: accessRoles,
  },
};
